import { CustomData } from 'lightweight-charts';
import { Series } from '../../models/series';

export interface StackedAreaData extends CustomData {
	values: number[];
}

export const transformToStackedAreaData = (seriesArray: Series[]): StackedAreaData[] => {
	// Return empty array if no series
	if (!seriesArray || seriesArray.length === 0) {
		return [];
	}

	// Find the series with the most complete data to use as reference
	const referenceSeriesIndex = seriesArray
		.map((s, index) => ({ index, length: s.points.length }))
		.sort((a, b) => b.length - a.length)[0].index;

	const data: StackedAreaData[] = seriesArray[referenceSeriesIndex].points.map((point) => ({
		time: point.time,
		values: seriesArray.map(s => {
			const matchingPoint = s.points.find(p => p.time === point.time);
			return matchingPoint ? matchingPoint.value : 0;
		})
	}));

	return data;
}